// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3mxQA","footer":"ModalUpdate_footer__1N1By"};